import { render, staticRenderFns } from "./InputEmpNo.vue?vue&type=template&id=5489e79a&scoped=true"
import script from "./InputEmpNo.vue?vue&type=script&lang=js"
export * from "./InputEmpNo.vue?vue&type=script&lang=js"
import style0 from "./InputEmpNo.vue?vue&type=style&index=0&id=5489e79a&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5489e79a",
  null
  
)

export default component.exports